export interface IControlStatus {
    name: string,
    desc: string
}
export interface IControlStatuses {
    STOP: IControlStatus,
    START: IControlStatus
}
export const ControlStatus = {
    'STOP': {
        name: 'Stopped ⏹',
        desc: 'OriCollector is stopped.'
    },
    'START': {
        name: 'Running ▶️',
        desc: 'OriCollector is running.<br>Started at {0}.'
    },
    'PAUSE': {
        name: 'Paused <span class="blink-me">⏸</span>',
        desc: 'OriCollector is paused.<br>Click "Resume" when ready.'
    },
    'FINISH': {
        name: 'Finished 🎉',
        desc: 'OriCollector has finished.<br>You can start a new job.'
    }
}